import React from 'react';

import { Accordion } from '@gumtree/ui-library';

import { StyledRange } from './range-filter-frame.style';
import type { Filter, FiltersDictionary, FilterKey } from '../../types';
import RangeFilter from '../filters/range-filter';
import { EXPANDED_FILTERS } from '../shared/constants';
import { getRangeFilterValues } from '../filters/range-filter/util';
import { trackFilterOpenChange } from '../shared/filters-utils';

const RangeFilterFilter = ({
    currentFilterStates,
    filtersDictionary,
    filterKey,
}: {
    currentFilterStates: Filter;
    filtersDictionary: FiltersDictionary;
    filterKey: FilterKey;
}) => {
    try {
        const { minKey, maxKey, minValues, maxValues, label, initialMinValue, initialMaxValue } =
            getRangeFilterValues(filtersDictionary[filterKey]);

        const minCount = currentFilterStates[minKey] as string | undefined;
        const maxCount = currentFilterStates[maxKey] as string | undefined;

        return (
            <Accordion
                title={label}
                isDefaultOpened={EXPANDED_FILTERS.includes(filterKey)}
                onOpenChange={(open: boolean) => {
                    trackFilterOpenChange(open, filterKey);
                }}
            >
                <StyledRange>
                    <RangeFilter
                        filterKey={filterKey}
                        initialMinValue={initialMinValue}
                        initialMaxValue={initialMaxValue}
                        maxValues={maxValues}
                        maxKey={maxKey}
                        minValues={minValues}
                        minKey={minKey}
                        minCount={minCount || initialMinValue}
                        maxCount={maxCount || initialMaxValue}
                        isStateful
                    />
                </StyledRange>
            </Accordion>
        );
    } catch (_error) {
        return <></>;
    }
};

export default RangeFilterFilter;
